module.exports = __webpack_public_path__ + "static/media/3DPPA20.f64aac11.jpg";